/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import {configuracaoModuleName} from "../../../shared/services/data.service";
import {ObrigacaoTipoNavigationService} from "../../obrigacoes/obrigacao-tipos/shared/obrigacao-tipo-navigation.service";
import {LicenciamentoNavigationService} from "../../licenciamentos/shared/licenciamento-navigation.service";
import {obrigacaoTiposModuleName} from "../../obrigacoes/obrigacao-tipos/shared/data.service";
import {licenciamentosModuleName} from "../../licenciamentos/shared/data.service";
import {obrigacoesModuleName} from "../../obrigacoes/shared/data.service";

@Component({
    template: require('./despacho-configuracao-obrigacoes.component.html')
})
export class DespachoConfiguracaoObrigacoesComponent implements OnInit {
    module: any = obrigacoesModuleName;
    configuracaoModule: any = configuracaoModuleName;
    obrigacaoTiposModule: any = obrigacaoTiposModuleName;
    licenciamentoModule: any = licenciamentosModuleName;

    constructor(
        private _obrigacaoNavigationService: ObrigacaoTipoNavigationService,
        private _licenciamentoNavigationService: LicenciamentoNavigationService
    ) { }

    ngOnInit() {
    }

    clickItem(module: any) {
        if (module.plural === this.obrigacaoTiposModule.plural) {
            this._obrigacaoNavigationService.goToList();
        } else if (module.plural === this.licenciamentoModule.plural) {
            this._licenciamentoNavigationService.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/configuracao/configuracao-obrigacoes/despacho-configuracao-obrigacoes.component.ts
 **/